/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeExpiredPasswordRequest
 */
export interface ChangeExpiredPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeExpiredPasswordRequest
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeExpiredPasswordRequest
     */
    currentPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeExpiredPasswordRequest
     */
    newPassword?: string;
}

export function ChangeExpiredPasswordRequestFromJSON(json: any): ChangeExpiredPasswordRequest {
    return ChangeExpiredPasswordRequestFromJSONTyped(json, false);
}

export function ChangeExpiredPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeExpiredPasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'currentPassword': !exists(json, 'currentPassword') ? undefined : json['currentPassword'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
    };
}

export function ChangeExpiredPasswordRequestToJSON(value?: ChangeExpiredPasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'currentPassword': value.currentPassword,
        'newPassword': value.newPassword,
    };
}

